import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import isUndefined from "lodash/isUndefined";
export var getLeadTimeText = function(lowerBoundDays, upperBoundDays, strictLocalize) {
    if (isUndefined(lowerBoundDays) || isUndefined(upperBoundDays)) {
        return undefined;
    }
    if (lowerBoundDays === upperBoundDays || lowerBoundDays === 0) {
        return strictLocalize({
            id: "FXPxJp",
            defaultMessage: [
                {
                    type: 6,
                    value: "count",
                    options: {
                        one: {
                            value: [
                                {
                                    type: 0,
                                    value: "Ships in "
                                },
                                {
                                    type: 7
                                },
                                {
                                    type: 0,
                                    value: " day"
                                }
                            ]
                        },
                        other: {
                            value: [
                                {
                                    type: 0,
                                    value: "Ships in "
                                },
                                {
                                    type: 7
                                },
                                {
                                    type: 0,
                                    value: " days"
                                }
                            ]
                        }
                    },
                    offset: 0,
                    pluralType: "cardinal"
                }
            ]
        }, DEPRECATED_backwardsCompatibleValues({
            count: upperBoundDays
        }));
    }
    return strictLocalize({
        id: "z+72dZ",
        defaultMessage: [
            {
                type: 0,
                value: "Ships within "
            },
            {
                type: 1,
                value: "lower"
            },
            {
                type: 0,
                value: "-"
            },
            {
                type: 1,
                value: "upper"
            },
            {
                type: 0,
                value: " days"
            }
        ]
    }, DEPRECATED_backwardsCompatibleValues({
        lower: lowerBoundDays,
        upper: upperBoundDays
    }));
};
